import $ from 'jquery';
import autosize from 'autosize';

$(function() {
  const maxFileSize = 30 * 1024 * 1024;

  /** Files and images
   ** ---------------------------------------------------------------- */

  /* remove file */
  $('.xi-remove-file').on('click', function() {
    const button = $(this);

    $.confirm('Diese Datei wirklich löschen?', false, function() {
      const container = button.closest('.xi-file');

      container
        .find('.xi-remove-file-input')
        .val('true')
        .end()
        .find('.xi-add-file')
        .fadeIn()
        .end()
        .find('.xi-stored-file')
        .add(container.nextAll('.xi-file-description').first())
        .add(container.nextAll('.xi-image-align').first())
        .slideUp(function() {
          $(this).filter('.xi-stored-file').remove();
          return false;
        });

      $.notify(
        'Datei löschen',
        [
          'Die Datei wurde zum Löschen ',
          'vorgemerkt. Um sie dauerhaft zu entfernen, ',
          'müssen Sie den Eintrag speichern.',
        ].join(''),
      );
    });

    return false;
  });

  $('.xi-new-file').each(function() {
    const $this = $(this);
    const container = $this.closest('.xi-file');

    if (
      container.find('.error').length === 0 &&
      container.find('.xi-add-file').length > 0
    ) {
      $this.hide();
    }
    if (container.find('.xi-stored-file').length === 0) {
      var desc = container.nextAll('.xi-file-description').first();
      desc.find('input, textarea').first().val('');

      if (container.find('.xi-add-file').length > 0) {
        desc.add(container.nextAll('.xi-image-align').first()).hide();
      }
    }

    $this.on('change', 'input[type="file"]', function(event) {
      const input = event.currentTarget;
      const errors = [];
      if (input.files?.length > 0) {
        for (let file of input.files) {
          if (file.size > maxFileSize) {
            errors.push(
              `Die Datei "${file.name}" ist zu groß. Die Datei darf maximal 32 MB groß sein.`,
            );
          }
        }
      }

      if (errors.length > 0) {
        errors.forEach((msg) => {
          $('<p class="error"></p>')
            .text(msg)
            .insertAfter(input)
            .hide()
            .slideDown();
        });
        input.value = '';
      } else {
        container.find('p.error').slideUp(function() {
          $(this).remove();
        });
      }
    });
  });

  $('.xi-file .xi-stored-file, .xi-file .error')
    .closest('.xi-file')
    .find('.xi-add-file')
    .hide();
  $('form').on('click', '.xi-add-file', function() {
    var container = $(this).hide().closest('.xi-file');
    var desc = container.nextAll('.xi-file-description').first();
    desc.find('input, textarea').first().val('');
    container
      .find('.xi-new-file')
      .add(desc)
      .add(container.nextAll('.xi-image-align').first())
      .fadeIn();
    return false;
  });

  /* Sorting / Removing
   * ---------------------------------------------------------------- */

  // TODO: hide/toggle up/down buttons on first/last element

  $('form').on('click', '.xi-sortable .xi-move-up', function() {
    const item = $(this).closest('.xi-array-element');
    const prev = item.prev('.xi-array-element');
    item.swapWith(prev);
    return false;
  });

  $('form').on('click', '.xi-sortable .xi-move-down', function() {
    const item = $(this).closest('.xi-array-element');
    const next = item.next('.xi-array-element');
    item.swapWith(next);
    return false;
  });

  $('.xi-appendable').each(function() {
    const list = $(this);
    const template = list
      .siblings('.xi-template:first')
      .find('.xi-array-element:first')
      .detach();

    list
      .data('count', list.children('.xi-array-element').length)
      .parent()
      .find('.xi-append')
      .first()
      .on('click', function() {
        const count = list.data('count');
        list.data('count', count + 1);

        template
          .clone(true)
          .find(':input, label')
          .each((_i, el) => {
            ['name', 'id', 'for'].forEach((key) => {
              const $el = $(el);
              const value = $el.attr(key);
              if (value && value.endsWith('[]')) {
                $el.attr(key, value.replace(/\[\]/, `[${count}]`));
              }
            });
          })
          .end()
          .appendTo(list);

        autosize(document.querySelectorAll('textarea.autosize'));

        return false;
      });

    $(window).on('resize', () => {
      const fields = document.querySelectorAll('textarea.autosize');

      if (fields != null) {
        setTimeout(() => {
          autosize.update(fields);
        }, 200);
      }
    });

    $('form').on('click', '.xi-appendable .xi-remove', function() {
      // TODO: confirm + notify?
      const item = $(this).closest('.xi-appendable > div');

      $.confirm('Dieses Element wirklich löschen?', false, function() {
        item.fadeOut('slow', function() {
          $(this).remove();
          $.notify(
            'Element löschen',
            `Das Element wurde entfernt. Damit es dauerhaft gelöscht 
             wird, müssen Sie den Eintrag speichern.`,
          );
        });
      });

      return false;
    });
  });

  /* Count chars
   * ---------------------------------------------------------------- */

  $('.xi-count-chars')
    .filter('input, textarea')
    .each(function() {
      const input = $(this);
      const display = input.closest('.form-group').find('.xi-chars-left');
      const max = parseInt(display.text(), 10);

      function update() {
        const l = input.val().length;
        display.text(Math.max(0, max - l));
        if (l > max) {
          display.removeClass('xi-count-warn');
          display.addClass('xi-count-err');
        } else if (l >= max - 20) {
          display.removeClass('xi-count-err');
          display.addClass('xi-count-warn');
        } else {
          display.removeClass('xi-count-err xi-count-warn');
        }
      }

      input.off('.xi-count-chars').on(
        `keyup.xi-count-chars
           mousedown.xi-count-chars
           mouseup.xi-count-chars
           focus.xi-count-chars
           blur.xi-count-chars
           change.xi-count-chars
           update.xi-count-chars`,
        update,
      );

      setInterval(update, 250);

      update();
    });

  /** Collapsible panel
   ** ---------------------------------------------------------------- */

  (function() {
    $('.xi-collapsible-panel')
      .addClass('collapsed')
      .find('.panel-content')
      .hide()
      .end()
      .find('> h3')
      .on('click', function() {
        const panel = $(this).closest('.xi-collapsible-panel');

        if (panel.hasClass('collapsed')) {
          panel
            .siblings('.xi-collapsible-panel:not(.collapsed)')
            .addClass('collapsed')
            .children('.panel-content')
            .slideToggle('slow');
        }

        panel
          .toggleClass('collapsed')
          .children('.panel-content')
          .slideToggle('slow');

        return false;
      });
  })();
});
